import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/index.css';

const isLocalHost = /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
if (import.meta.env.PROD && window.location.protocol === 'http:' && !isLocalHost) {
  const httpsUrl = `https://${window.location.host}${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(httpsUrl);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
